import React from 'react';
import styled from 'styled-components';
import {createGlobalStyle} from 'styled-components';
import SubmitBtn from '../button/SubmitBtn';
import NormalBtn from '../button/NormalBtn';
import { useSelector, useDispatch } from 'react-redux';
import SpanDetailPrice from '../price/SpanDetailPrice';

import { useEffect } from 'react';
import { useState } from 'react';
import { setSelOptionInfoAction, getProdOptionAction, setSelProdInfoAction, getProdOptPriceAction, resetOptPriceAction } from '../../../modules/common/prodModule';
import SelectDropDownBtn from '../button/SelectDropDownBtn';
import ProdDetailOptionItem from './ProdDetailOptionItem';
import { esApplyProdDao, esApplyOptionDao, setEsApplyProdAction } from '../../../modules/es/esApplyModule';
import { setEsMyApplyProdAction } from '../../../modules/es/esMyModule';
import { setUserCartProdsAction, addUserCartProdAction, syncUserCartAction } from '../../../modules/su/userCartModule';
import Modal from 'react-modal';
import NormalPopup, { customModalStyles } from '../popup/NormalPopup';
import { useHistory, Link } from 'react-router-dom';
import loadingReducer from '../../../modules/common/loadingModule';
import { each, filter, forEach, findIndex, remove, reduce } from 'lodash';
import { useRef } from "react";
import ProdDetailOptSelect from './ProdDetailOptSelect';
import { getProdOptPrice } from '../../../lib/api/prodapi';
import { isMobileOnly } from 'react-device-detect';

import { LoginPopupStyles } from '../../common/popup/LoginPopup';
import LoginPopup from '../../common/popup/LoginPopup';
import { setUserProdAddAction, setUserProdDelAction, setClipProdIdAction } from '../../../modules/su/userProdModule';
import { setUserBrandAddAction, setUserBrandDelAction } from '../../../modules/common/brandModule';
import { setClipBrandIdAction } from '../../../modules/su/userBrandModule';
import $ from 'jquery';
import NormalPopupOneBtn from '../popup/NormalPopupOneBtn';
import LoadingOverlay from 'react-loading-overlay';

const GlobalStyle = createGlobalStyle`
    body {
        ${props=>props.showOption?`            
            // position: fixed;
            overflow: hidden;
            width: 100vw;
            height: 100%            
        `:`
            width: 100vw;
            position: relative;
        `}

        .pd_tfoot2.desktop {
            padding-top: 20px;
            ${props=>props.isSelected?"border-top:2px solid #111;":""}
        }

    }
`
const ProdDetailOptionBlock = styled.div`
    width: ${isMobileOnly?"100%":"800px"};
    position: fixed;
    bottom: 0;
    left: 0 ;
    //height: 102px;
    z-index: ${isMobileOnly?"101":"20"};
    ${props=>props.showOption&&`
        height: 100%;
        background-color: rgba(17, 17, 17, 0.3);
    `}
`;
const BottomFixedDrawerContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    position: relative;
    // overflow: hidden;
    /*JP responsive*/
    ${!isMobileOnly && `
        // float: left;
        //  width: 47.9%; 
        // width: 538px;        
        // padding: 0px 0px 0px 50px;        
    `};
    //${isMobileOnly && `margin:20px 16px 0 16px; width: 92vw;`};

    // .action-block {
    //     ${isMobileOnly ? `display:flex` : "margin-top:14px"};
    //
    // }
    .drawer-container {
        
        ${isMobileOnly&&`
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-end;                
        `}
        position:relative;z-index:999;
    }
    .upper-blank {
        height: 10px;
        width: ${isMobileOnly?"100vw":"800px"};
    }
    .pd-handler {
        margin: 0 auto;
        width: 50px;
        height: 8px;
        border-radius: 4px;
        background-color: #ffffff;
        margin-bottom: 10px;
        //touch-action: none;
        //border: 1px solid #ccc;
        //box-shadow: 0 2px 2px 1px rgba(0,0,0,0.3);
        ${props=>props.showOption?'opacity:1; visibility:visible;':'opacity: 0;transition: visibility 0s, opacity 0.5s linear;'}
    }
    
    .pd-bottom-fixed-drawer {
        width: 100%;
        background-color: #fff;

        ${isMobileOnly&&`
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;        
        `}
        

        //border: 1px solid #cccccc;
        ${props=>props.showOption&&`
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
        `};
        //box-shadow: 0 -2px 3px 0 rgba(0,0,0,0.3);
        
        .pd-option-detail{
            width:100%;
            
            &.show {
                max-height: 65vh;
                transition: max-height 0.25s ease-in;
                padding:20px 16px 0;
            }
            &.hide {
                max-height: 0;
                transition: max-height 0.15s ease-out;
                overflow: hidden;
                padding:0 16px;
            }
            .pd_obj-table2 {
                padding: ${props=>props.isOption?"10px 0 0":"0"};
                &:last-of-type {padding-bottom:10px;}
                border-radius: 4px;
                .pd_tbody2 > div {
                    margin-bottom:10px;
                    padding: 14px 0 14px 13px;
                    border-radius: 4px;
                    border: solid 1px #cccccc;
                }
                
            }
        }
        .ft {
            background-color: white;
            z-index: 1;
            .horizontal-separator { display:block; height:1px; width:${isMobileOnly?"100vw":"800px"}; background-color:#cccccc;}
            .pd_tfoot2 {
                ${props=>props.showOption?`
                    margin: 24px 4vw 0 4vw;
                    opacity:1; visibility:visible;
                `:`
                    display: none;
                `}
            }
            .pd-buttons {
                ${isMobileOnly?"margin: 20px 10px 30px":"padding: 20px 40px 40px"};
            }
        }
    }


`;
const ProdDetailOptionTitleBlock = styled.div`
    line-height: 1.4;
    width: ${isMobileOnly ? "90vw" : "440px"};
    margin-bottom: 35px;
    font-size: 24px;
    font-weight: 500;
`;

const ProdDetailPdTitleBlock = styled.h3`
    line-height: 1.4;
    width: ${isMobileOnly ? "90vw" : "440px"};
    margin-bottom: 35px;
    font-size: 24px;
    font-weight: 500;
    ${isMobileOnly && `margin-top:15px`};
`;

const ProdPdBtnWrapBlock = styled.h3`
    position: absolute;
    top: 0px;
    right: ${isMobileOnly ? "0" : "0"};
`;


let optionTitle1 = "";
let optionTitle2 = "";
let optionTitle3 = "";

// 선택된 옵션 정보 값
// let seletedOptions = [];
let selOpt1 = null;
let selOpt2 = null;
let selOpt3 = null;

var totalprice = 0;

const ProdDetailOption2 = ({ prodinfo, onReqClose }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [curProdId, setCurProdId] = useState(null);

    // prodinfo 에 있는 옵션 정보 저장
    const [opt1, setOpt1] = useState([]);
    const [opt2, setOpt2] = useState([]);
    const [opt3, setOpt3] = useState([]);

    // 옵션별 서버로 부터 받은 정보 저장
    const [curOptInfo1, setCurOptInfo1] = useState(null);
    const [curOptInfo2, setCurOptInfo2] = useState(null);
    const [curOptInfo3, setCurOptInfo3] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [openModalCntOver, setOpenModalCntOver] = useState(false);

    const optionRef = useRef([React.createRef(), React.createRef(), React.createRef()]);
    const handlerRef = useRef(null);

    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [isClipAdd, setIsClipAdd] = useState(false);
    const [isClipDel, setIsClipDel] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);

    const [showOption, setShowOption] = useState(false);
    const [startY, setStartY] = useState(0);
    const [moveY, setMoveY] = useState(0);

    // Redux Store에서 저장된 값을 가져옴
    var { selectedBrandItem, selectedOptionItems, accessToken, cartProdList,
        curMenu, optInfo1, optInfo2, optInfo3, clipProdIds, prodClipResult, id, clipBrandIds, brandClipResult,openMenu } = useSelector(
            ({ brandItemsReducer, prodItemsReducer, headerReducer,
                userReducer, userCartReducer, userProdReducer, userBrandReducer }) => ({
                    selectedBrandItem: brandItemsReducer.selectedBrandItem,
                    selectedOptionItems: prodItemsReducer.selectedOptionItems,
                    curMenu: headerReducer.curMenu,
                    optInfo1: prodItemsReducer.optInfo1,
                    optInfo2: prodItemsReducer.optInfo2,
                    optInfo3: prodItemsReducer.optInfo3,
                    accessToken: userReducer.accessToken,
                    cartProdList: userCartReducer.cartProdList,
                    clipProdIds: userProdReducer.clipProdIds, // 상품찜 추가
                    prodClipResult: userProdReducer.prodClipResult,
                    id: userReducer.id,
                    clipBrandIds: userBrandReducer.clipBrandIds,
                    brandClipResult: brandItemsReducer.brandClipResult,
                    openMenu: headerReducer.openMenu,
                })
        );

    useEffect(()=>{
        if(isMobileOnly) {
            if(showOption){
                let a = window.scrollY;
                document.body.style.position = "fixed";
                document.body.style.top = `-${a}px`;
            } else {
                const scrollY = window.document.body.style.top;
                window.document.body.style.position = '';
                window.document.body.style.top = '';
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }
    },[showOption])

    //상품 찜 추가
    useEffect(() => {
        if (accessToken !== null) {
            onCloseModalLogin();
        }

        return () => {
        };

    }, [accessToken]);

    useEffect(() => {

        if (isClipAdd) {
            if (clipProdIds === null || clipProdIds === undefined || (clipProdIds && clipProdIds.length < 1)) {
                let clipSum = [];
                clipSum.push(curProdId);
                dispatch(setClipProdIdAction(clipSum));
                setIsClipAdd(false);
            }
            else {
                let clipSum = [...new Set(clipProdIds.concat(curProdId))];
                dispatch(setClipProdIdAction(clipSum));
                setIsClipAdd(false);
            }
        }
        else if (isClipDel) {
            if (clipProdIds != null) {
                let clipSum = [...clipProdIds];
                remove(clipSum, (obj) => { return obj === curProdId })
                dispatch(setClipProdIdAction(clipSum));
                setIsClipDel(false);
            }
        }

    }, [prodClipResult]);
    //로그인 팝업 뜨고 로그인 완료 후, 좋아요 리스트 요청(메인화면에서 요청) 후 처리.
    useEffect(() => {
        if (accessToken !== null && fromLoginPU === true) {

            //로그인 완료 후 이미 좋아요 포함되어 있는 경우 요청하지 않음.
            if (clipProdIds != null && clipProdIds.length > 0 && clipProdIds.includes(curProdId)) {

            }
            else {
                if (clipProdIds != null && clipProdIds.length > 499) {
                    alert("상품찜은 500개까지 가능합니다.")
                    return;
                }
                dispatch(setUserProdAddAction(id, curProdId));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
            setFromLoginPU(false);
        }

    }, [clipProdIds]);

    const onOpenModalLogin = () => {
        setOpenModalLogin(true);
    }

    // Modal 닫기
    const onCloseModalLogin = () => {
        setOpenModalLogin(false);
    }

    const onHandleLike = () => {
        //비로그인
        if (accessToken === null) {
            onOpenModalLogin();
            setFromLoginPU(true); //로그인 팝업 후, 종료시 다시 요청하기 위해서..
        }
        else {
            if (clipProdIds != null && clipProdIds.length > 0 && clipProdIds.includes(curProdId)) {
                dispatch(setUserProdDelAction(id, curProdId));
                setIsClipAdd(false);
                setIsClipDel(true);
            }
            else {
                if (clipProdIds != null && clipProdIds.length > 499) {
                    alert("상품찜은 500개까지 가능합니다.")
                    return;
                }
                dispatch(setUserProdAddAction(id, curProdId));
                setIsClipAdd(true);
                setIsClipDel(false);
            }
        }

    }

    const getLikeBtnImg = () => {

        //비로그인
        if (accessToken === null) {
            // return "/assets/images/icon/favorite-icon.png"
            return "/assets/images/icon/favorite-icon-gray.png"
        }
        else {
            if (clipProdIds != null && clipProdIds.length > 0 && clipProdIds.indexOf(curProdId) > -1) {
                // return "/assets/images/icon/favorite-icon-black.png"
                return "/assets/images/icon/favorite-icon.png"
            }
            else {
                // return "/assets/images/icon/favorite-icon.png"
                return "/assets/images/icon/favorite-icon-gray.png"
            }

        }
    }

    const getLikeBgColor = () => {

        //비로그인
        if (accessToken === null) {
            // return "#e0e0e0"
            return "#ececec";
        }
        else {
            if (clipProdIds != null && clipProdIds.length > 0 && clipProdIds.indexOf(curProdId) > -1) {
                return "#79b88a"
            }
            else {
                // return "#e0e0e0"
                return "#ececec";
            }

        }
    }

    // 최초에 들어 오면 실행
    useEffect(() => {

        if (prodinfo !== null) {
            setCurProdId(prodinfo.prdct_id);
            initComp();
            dispatch(getProdOptPriceAction(prodinfo.prdct_id, null, null))
        }

        if (prodinfo !== null && (prodinfo.opt1_nm === null || prodinfo.opt1_nm.length === 0)) {
            // 옵션이 없는 경우 추가
            saveNoOptionInfo()
        }

    }, [curProdId, prodinfo])


    useEffect(() => {

        if (curOptInfo1 !== optInfo1) {
            setCurOptInfo1(optInfo1);
            makeSelectOptInfo(1, optInfo1);
        }

        if (curOptInfo2 !== optInfo2) {
            setCurOptInfo2(optInfo2);
            makeSelectOptInfo(2, optInfo2);
        }

        if (curOptInfo3 !== optInfo3) {
            setCurOptInfo3(optInfo3);
            makeSelectOptInfo(3, optInfo3);
        }

    }, [optInfo1, optInfo2, optInfo3]);


    // total 금액 계산
    if (selectedOptionItems.length > 0) {
        totalprice = selectedOptionItems.reduce((resultobj, curObj, idx) => {
            resultobj = (resultobj * 1) + (curObj.es_prdct_price * 1);
            return resultobj;
        }, []);
    } else {
        totalprice = 0;
    }

    // 초기화 처리
    const initComp = () => {

        selOpt1 = null;
        selOpt2 = null;
        selOpt3 = null;

        setOpt1([]);
        setOpt2([]);
        setOpt3([]);

        // 옵션 정보 설정
        makeOptionValues(1, prodinfo.opt1_val);
        makeOptionValues(2, prodinfo.opt2_val);
        makeOptionValues(3, prodinfo.opt3_val);

        // 옵션 title 설정
        optionTitle1 = prodinfo.opt1_nm;
        optionTitle2 = prodinfo.opt2_nm;
        optionTitle3 = prodinfo.opt3_nm;
    }

    // 서버로 부터 받은 option 정보로 옵션 테이블 다시 생성
    const makeSelectOptInfo = (index, optinfo) => {
        let targetObj = [];
        if (optinfo === null || optinfo === undefined) return;

        forEach(optinfo, (curitem, idx) => {
            targetObj.push({
                value: idx,
                label: curitem.label.trim(),
                disabled: curitem.status === 0 || prodinfo.sell_status !== '020102',
                price: curitem.price,
                optid: curitem.id
            });
        })

        // State Update
        if (index === 1) {
            setOpt1(targetObj);
        } else if (index === 2) {
            setOpt2(targetObj);
        } else {
            setOpt3(targetObj);
        }
    }


    // 최초 로딩시 컴포넌트에 설정될 옵션 정보 만들기
    const makeOptionValues = (index, optionValue) => {

        let targetObj = [];

        // 초기화
        if (optionValue && optionValue.length > 0) {
            targetObj = [];
            let options = optionValue.split(",");
            let i = 0;
            while (i < options.length) {
                targetObj.push({ value: i, label: options[i].trim(), disabled: false });
                i++;
            }

            // State Update
            if (index === 1) {
                setOpt1(targetObj);
            } else if (index === 2) {
                setOpt2(targetObj);
            } else {
                setOpt3(targetObj);
            }
        }

    }


    // 수납합에 담기 버튼 클릭
    const handlerClickSubmit = () => {

        if (isMobileOnly&&!showOption) {
            //모바일에서만 드로워 사용
            setShowOption(true);
            return;
        }


        // 추가한 옵션이 없으면 동작 return
        if (selectedOptionItems.length === 0) {
            if(!!showOption) {setShowOption(false)}
            return;
        }

        // [START] 현재 견적서 상품 정보 리스트에 추가
        // 옵션 정보 루프 돌면서 추가
        const reqApplyItems = selectedOptionItems.reduce((resultObj, curobj, idx) => {
            let addItem = esApplyProdDao();
            addItem.prdct_id = prodinfo.prdct_id;
            addItem.prdct_nm = prodinfo.prdct_nm;
            addItem.opt_id = curobj.opt_id;
            addItem.opt_nm = curobj.opt_nm;
            addItem.cate_name = prodinfo.cate2_name;
            addItem.prdct_price = prodinfo.prdct_price; // 판매가
            addItem.sale_price = prodinfo.sale_price;
            addItem.es_prdct_price = curobj.es_prdct_price; // 견적 요청 상품 금액 ( 옵션 금액 포함 )
            addItem.es_opt_pirce = curobj.es_opt_pirce; // 옵션 금액
            addItem.qty = curobj.qty;
            addItem.img = prodinfo.repr_img;
            addItem.brnd_id = prodinfo.brnd_id;
            addItem.brnd_nm = prodinfo.brnd_han;
            addItem.brnd_logo_url = prodinfo.brnd_logo;
            addItem.reg_date = new Date().toISOString().slice(0, 19).replace('T', ' ');
            //console.log("reg_date = " + addItem.reg_date)
            //[START] #2726 수정
            try {
                addItem.brnd_cd = prodinfo.brand[0].brnd_cd;
            }
            catch (e) {
                // Do nothing!
            }
            //[END] #2726 수정

            resultObj.push(addItem);
            return resultObj;
        }, [])

        setShowOption(false);
        // 수납함에 담기
        if (curMenu === 'pd') {

            // 기존에 브랜드 아이디가 없는 항목은 삭제
            remove(cartProdList, (curitem) => {
                return curitem.brnd_id === 0;
            })

            // [START] #2605 - 신규 추가 인데, 브랜드 갯수가 30개 이상이면 추가 안됨
            let brndCnt = 0;
            if (cartProdList !== undefined && cartProdList !== null) {
                forEach(cartProdList, (curItem) => {
                    if (curItem.brnd_id !== undefined && curItem.brnd_id === reqApplyItems[0].brnd_id) {
                        brndCnt++;
                    }
                })
            }
            // [END] #2605 - 신규 추가 인데, 브랜드 갯수가 30개 이상이면 추가 안됨

            if (brndCnt + reqApplyItems.length > 30) {
                setOpenModalCntOver(true);
            } else {
                if (accessToken !== null) {

                    reqApplyItems.map((curitem) => {

                        // 추가할 아이템이 이미 추가 되어 있는지 확인
                        let objIdx = findIndex(cartProdList, (obj) => {
                            return (obj.prdct_id === curitem.prdct_id && obj.opt_id === curitem.opt_id);
                        })

                        // console.log(objIdx + " : " + JSON.stringify(arrAddItems));
                        // 신규 추가 의 경우
                        if (objIdx === -1) {
                            if (curitem.brnd_id !== 0
                                && curitem.brnd_nm !== null
                                && curitem.brnd_nm.length > 0) {
                                cartProdList.push(curitem);
                            }

                        } else {
                            // 갯수 증가 시키고 전체 금액 계산
                            let qty = ++cartProdList[objIdx].qty;
                            let price = cartProdList[objIdx].es_opt_pirce;
                            cartProdList[objIdx].es_prdct_price = (price * qty);
                        }

                        return null;
                    })

                    dispatch(syncUserCartAction(cartProdList));
                    // TODO::내가구견적요청서로 데이터전달
                } else {
                    dispatch(setUserCartProdsAction(reqApplyItems));
                    // TODO::내가구견적요청서로 데이터전달
                }
                // 모달 표시
                setOpenModal(true);
            }

        } else {
            // 견적함에 담기
            //dispatch(setEsApplyProdAction(reqApplyItems));
            dispatch(setEsMyApplyProdAction(reqApplyItems));
            // 옵션 정보 초기화
            dispatch(setSelOptionInfoAction([]));
            dispatch(resetOptPriceAction());
            // 모달 닫기
            if(isMobileOnly) {
                history.goBack();
            } else {
                onReqClose();
            }
        }
        //[END] 현재 견적서 상품 정보 리스트에 추가
    }


    /**
     * 옵션 1 변경 처리
     * @param {*} param
     */
    const onChangeOption1 = (param) => {
        selOpt1 = param.label;
        // 하나만 있는 경우
        if (opt2.length === 0) {
            // 옵션 저장
            saveOptionInfo(param);
        } else {
            // 2 depth 옵션 정보 가져오기
            dispatch(getProdOptPriceAction(prodinfo.prdct_id, selOpt1, null))
        }
    }

    /**
     * 옵션 2 변경 처리
     * @param {*} param
     */
    const onChangeOption2 = (param) => {
        selOpt2 = param.label;
        // 3depth 옵션이 없으면
        if (opt3.length === 0) {
            saveOptionInfo(param);
        } else {
            // 3 Depth 옵션 정보 가져오기
            dispatch(getProdOptPriceAction(prodinfo.prdct_id, selOpt1, selOpt2))
        }
    }

    /**
     * 옵션 3 변경 처리
     * @param {*} param
     */
    const onChangeOption3 = (param) => {
        if(!!selOpt1&&!!selOpt2){
            selOpt3 = param.label;
            saveOptionInfo(param);
        }
    }

    // 옵션 추가 하기 전에 validateion check
    const validBeforeSaveOption = () => {

        if (selOpt1 === null && selOpt2 === null && selOpt3 === null) {
            // 옵션이 전부 선택되지 않았으므로 아무것도 하지 않음
            return false;
        }

        // 옵션이 2개 인 경우
        if (opt2.length > 0 && opt3.length === 0) {
            if ((selOpt2 === null || selOpt2 === '')) {
                return false;
            }
        }

        // 옵션이 3개 인 경우
        if (opt3.length > 0) {
            if ((selOpt3 === null || selOpt3 === '')) {
                return false;
            }
        }

        return true;
    }

    // 옵션 정보를 추가 한 다음 선택 옵션 초기화
    const resetOptAfterSave = () => {
        selOpt1 = null;
        selOpt2 = null;
        selOpt3 = null;

        optionRef.current[0].current.focus();
    }

    const saveNoOptionInfo = () => {

        // console.log("saveNoOptionInfo =======>")
        selectedOptionItems = [];
        let es_prdct_price = prodinfo.sale_price;

        // 옵션 정보 저장
        let optObj = esApplyOptionDao();
        optObj.qty = 1;
        optObj.opt_nm = prodinfo.prdct_nm;
        optObj.prdct_id = prodinfo.prdct_id;
        optObj.es_prdct_price = es_prdct_price;//견적 요청 상품 금액 (옵션 금액 포함) (sale_price + opt_price) * qty;
        optObj.es_opt_pirce = es_prdct_price; // 견적 요청 상품 옵션 금액 ( sale_price + opt_pirce )

        selectedOptionItems.push(optObj);

        // 옵션 정보 추가
        dispatch(setSelOptionInfoAction(selectedOptionItems));
    }

    /**
     * 옵션 선택 후 저장
     */
    const saveOptionInfo = (param) => {

        if (!validBeforeSaveOption()) {
            return;
        }


        // 동일 옵션 있는지 체크해서 있으면 갯수만 증가
        let objIdx = findIndex(selectedOptionItems, (curitem) => {
            return curitem.opt_id === param.optid;
        })

        // 없으면 추가
        if (objIdx === -1) {
            let es_prdct_price = prodinfo.sale_price + param.price;

            // 옵션 이름 설정
            let optinfo = optionTitle1 + ":" + selOpt1;
            if (selOpt2 !== null) {
                optinfo = optinfo + "/" + optionTitle2 + ":" + selOpt2;

                if (selOpt3 !== null) {
                    optinfo = optinfo + "/" + optionTitle3 + ":" + selOpt3;
                }
            }

            // 옵션 정보 저장
            let optObj = esApplyOptionDao();
            optObj.opt1 = selOpt1;
            optObj.opt2 = selOpt2;
            optObj.opt3 = selOpt3;
            optObj.opt_nm = optinfo;
            optObj.opttitle1 = optionTitle1;
            optObj.opttitle2 = optionTitle2;
            optObj.opttitle3 = optionTitle3;
            optObj.qty = 1;
            optObj.prdct_id = prodinfo.prdct_id;
            optObj.es_prdct_price = es_prdct_price;//견적 요청 상품 금액 (옵션 금액 포함) (sale_price + opt_price) * qty;
            optObj.opt_id = param.optid;
            optObj.es_opt_pirce = es_prdct_price; // 견적 요청 상품 옵션 금액 ( sale_price + opt_pirce )
            optObj.opt_price = param.price;

            selectedOptionItems.push(optObj);
        } else {
            selectedOptionItems[objIdx].qty++;
            selectedOptionItems[objIdx].es_prdct_price = selectedOptionItems[objIdx].es_opt_pirce * selectedOptionItems[objIdx].qty;
        }

        // 옵션 정보 추가
        dispatch(setSelOptionInfoAction(selectedOptionItems));

        // 초기화
        resetOptAfterSave();
    }

    // 모달 닫기
    const handleModalClose = () => {
        setOpenModal(false);
    }

    // 모달 첫번째 버튼 처리
    const handleModalBtn1Click = () => {
        return history.push("/mycart")
    }

    // 모달 두번째 버튼 처리
    const handleModalBtn2Click = () => {
        handleModalClose();
    }

    const checkOptDisable = (type) => {
        // console.log("checkOptDisable : " + selOpt1 + ", selOpt2 : " + selOpt2 + ", selOpt3 : " + selOpt3);
        // 2 Depth
        if (type === 0) {
            if (selOpt1 === null || selOpt1 === '') {
                return true;
            }
        } else {
            if (selOpt1 === null || selOpt1 === ''
                || selOpt2 === null || selOpt2 === '') {
                return true;
            }
        }

        return false;
    }

    // console.log("selectedOptionItems : " + JSON.stringify(selectedOptionItems));
    const touchY = (event) => {
        //return;
        if ("touches" in event && event.touches.length >= 1) {
            const { clientX, clientY } =
              "touches" in event ? event.touches[0] : event;

            return clientY;
        }
        return;
    }

    const touchCancel = (e) => {

    }

    const touchEnd = (e) => {
        // console.log('touchEnd');
        if(isMobileOnly && startY > 0) {
            //if(moveY - startY > 70) {
            // if(handleClosePopup !== null && handleClosePopup !== undefined) {
            //     handleClosePopup();
                // setSelId(-1);
            setShowOption(false);
            // }
            //}
        }

        setMoveY(0);
        setStartY(0);
    }

    const touchMove = (e) => {
        // console.log('touchMove');
        if(isMobileOnly && startY > 0) {
            let moveY = touchY(e);
            setMoveY(moveY);
        }
    }

    const touchStart = (e) => {
        if(isMobileOnly && handlerRef && handlerRef.current){
            let startY = touchY(e);
            // console.log('topY = ' + handlerRef.current.getBoundingClientRect().top)

            if(startY - handlerRef.current.getBoundingClientRect().top < 40) {
                setStartY(startY);
            }
        }
    }

    return (
      <React.Fragment>
          {!isMobileOnly&&
          <React.Fragment>
              <div>
                  {prodinfo.opt1_nm&&prodinfo.opt1_nm.length > 0 ?
                    <ProdDetailOptSelect
                      reset={selOpt1 === null}
                      options={opt1}
                      reffer={optionRef.current[0]}
                      placeholder={prodinfo.opt1_nm}
                      marginBottom='10px' marginRight="2px"
                      onChange={onChangeOption1}
                    />
                    : ''}

                  {prodinfo.opt2_nm&&prodinfo.opt2_nm.length > 0 ?
                    <ProdDetailOptSelect
                      reset={selOpt2 === null}
                      isDisabled={checkOptDisable(0)}
                      options={opt2}
                      reffer={optionRef.current[1]}
                      placeholder={prodinfo.opt2_nm}
                      marginBottom='10px' marginRight="2px"
                      onChange={onChangeOption2} />
                    : ''}

                  {prodinfo.opt3_nm&&prodinfo.opt3_nm.length > 0 ?
                    <ProdDetailOptSelect
                      reset={selOpt3 === null}
                      isDisabled={checkOptDisable(1)}
                      options={opt3}
                      reffer={optionRef.current[2]}
                      placeholder={prodinfo.opt3_nm}
                      marginBottom='10px'
                      marginRight="2px"
                      onChange={onChangeOption3} />
                    : ''}
              </div>
              <div className="pd_obj-table2" style={selectedOptionItems === null || selectedOptionItems.length === 0 ? { borderTop: '0px',paddingBottom:"0" } : {}}>

                  <div className="pd_tbody2 small_scroll" style={{ "maxHeight": '36vh', "overflow":"auto" }}>
                      {
                          (selectedOptionItems === null || selectedOptionItems.length === 0) ?
                            ''
                            :
                            selectedOptionItems.map((item, idx) => {
                                return <ProdDetailOptionItem
                                  key={idx + 1} idx={idx + 1}
                                  optionInfo={item}
                                  hasOption={!(prodinfo !== null && (prodinfo.opt1_nm === null || prodinfo.opt1_nm.length === 0))}
                                />;
                            })
                      }
                  </div>
              </div>
              <div className="pd_tfoot2 desktop clearfix" style={selectedOptionItems === null || selectedOptionItems.length === 0 ? { borderTop: '0px' } : {}}>
                  <p className="pd_total f-left" style={{ fontSize: '14px', lineHeight: '14px', fontWeight:"500" }}>{curMenu === 'pd' ? '총 상품 금액' : '상품 금액'}</p>
                  <p className="pd_total_pay f-right" style={{ fontSize: "18px", lineHeight: '18px', fontWeight: "600" }}>
                      <span className="font-mont"> {Number((totalprice * 1).toFixed(1)).toLocaleString()}</span><span style={{ fontSize: "14px", lineHeight: '18px', fontWeight: "normal" }}>원</span>
                  </p>
              </div>
          </React.Fragment>
          }

        <ProdDetailOptionBlock showOption={showOption} >
            <GlobalStyle showOption={showOption} isSelected={selectedOptionItems.length}/>
            <BottomFixedDrawerContainer showOption={showOption} isOption={prodinfo.opt1_nm&&prodinfo.opt1_nm.length} >
                <div className="drawer-container" onTouchStart={touchStart} onTouchEnd={touchEnd} onTouchCancel={touchCancel} onTouchMove={touchMove}>
                <div className="upper-blank"/>
                <div className="pd-handler" ref={handlerRef}/>
                <div className="pd-bottom-fixed-drawer">
                    <div className={`pd-option-detail ${showOption?'show':'hide'}`}>
                        <div>
                            {prodinfo.opt1_nm&&prodinfo.opt1_nm.length > 0 ?
                              <ProdDetailOptSelect
                                reset={selOpt1 === null}
                                options={opt1}
                                reffer={optionRef.current[0]}
                                placeholder={prodinfo.opt1_nm}
                                marginBottom='10px' marginRight="2px"
                                onChange={onChangeOption1}
                              />
                              : ''}

                            {prodinfo.opt2_nm&&prodinfo.opt2_nm.length > 0 ?
                              <ProdDetailOptSelect
                                reset={selOpt2 === null}
                                isDisabled={checkOptDisable(0)}
                                options={opt2}
                                reffer={optionRef.current[1]}
                                placeholder={prodinfo.opt2_nm}
                                marginBottom='10px' marginRight="2px"
                                onChange={onChangeOption2} />
                              : ''}

                            {prodinfo.opt3_nm&&prodinfo.opt3_nm.length > 0 ?
                              <ProdDetailOptSelect
                                reset={selOpt3 === null}
                                isDisabled={checkOptDisable(1)}
                                options={opt3}
                                reffer={optionRef.current[2]}
                                placeholder={prodinfo.opt3_nm}
                                marginBottom='10px'
                                marginRight="2px"
                                onChange={onChangeOption3} />
                              : ''}
                        </div>

                        <div className="pd_obj-table2" style={selectedOptionItems === null || selectedOptionItems.length === 0 ? { borderTop: '0px',paddingBottom:"0" } : {}}>

                            <div className="pd_tbody2 small_scroll" style={{ "maxHeight": '30vh', "overflow":"auto" }}>
                                {
                                    (selectedOptionItems === null || selectedOptionItems.length === 0) ?
                                      ''
                                      :
                                      selectedOptionItems.map((item, idx) => {
                                          return <ProdDetailOptionItem
                                            key={idx + 1} idx={idx + 1}
                                            optionInfo={item}
                                            hasOption={!(prodinfo !== null && (prodinfo.opt1_nm === null || prodinfo.opt1_nm.length === 0))}
                                          />;
                                      })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="ft" style={{display: openMenu? 'none':'block'}}>
                        <div className="horizontal-separator" />
                        <div className="pd_tfoot2 clearfix" style={selectedOptionItems === null || selectedOptionItems.length === 0 ? { borderTop: '0px' } : {}}>
                            <p className="pd_total f-left" style={{ fontSize: '14px', lineHeight: '14px', fontWeight:"500" }}>{curMenu === 'pd' ? '총 상품 금액' : '상품 금액'}</p>
                            <p className="pd_total_pay f-right" style={{ fontSize: "18px", lineHeight: '18px', fontWeight: "600" }}>
                                <span className="font-mont"> {Number((totalprice * 1).toFixed(1)).toLocaleString()}</span>원
                            </p>
                        </div>
                        <div className="pd-buttons flex jsb">
                            <div style={{ width: (isMobileOnly ? '18%' : '110px')}}>
                                <NormalBtn
                                  width="100%" height={isMobileOnly?"52px":"60px"}
                                  marginTop="0px"
                                  bgColor={getLikeBgColor()}
                                  img={getLikeBtnImg()}
                                  onClick={() => onHandleLike()}
                                />
                            </div>
                            <div style={{ width: (isMobileOnly ? '79%' : '590px'), marginLeft: '10px' }}>
                                {prodinfo.opt_status&&prodinfo.sell_status==='020102'?
                                  <SubmitBtn text={curMenu === 'pd'? `장바구니에 담기 ${!!selectedOptionItems.length?"👍":""}`:`상품 담기 ${!!selectedOptionItems.length?"👍":""}`}
                                             fontSize="16px"
                                             fontWeight="normal"
                                             arrowDirction="none"
                                             marginTop="0px"
                                             width="100%" height={isMobileOnly?"52px":"60px"}
                                             textColor="#fff" bgColor="#111"
                                             arrowColor="#fff"
                                             onClick={handlerClickSubmit} />
                                  :
                                  <SubmitBtn text='품절'
                                             fontSize="16px"
                                             fontWeight="normal"
                                             arrowDirction="none"
                                             marginTop="0px"
                                             width="100%" height="52px"
                                             textColor="#bbbbbb" bgColor="#e0e0e0"
                                             arrowColor="#fff"
                                  />

                                }
                            </div>

                        </div>
                    </div>
                </div>
                </div>
            </BottomFixedDrawerContainer>

            <Modal isOpen={openModal}
                onRequestClose={handleModalClose}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopup
                    text=""
                    text2="장바구니에 추가 되었습니다." text3=""
                    btn1="상품 보러가기"
                    btn2="닫기"
                    onClick1={handleModalBtn1Click}
                    onClick2={handleModalBtn2Click} />
            </Modal>
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>
            <Modal
                isOpen={openModalCntOver}
                onRequestClose={() => { setOpenModalCntOver(false) }}
                style={customModalStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <NormalPopupOneBtn
                    text=""
                    text2="견적 요청은 30개 이하만 가능합니다!"
                    text3="조금만 덜어주세요. :-)"
                    btn="닫기"
                    onClick={() => { setOpenModalCntOver(false) }} />
            </Modal>
        </ProdDetailOptionBlock >
      </React.Fragment>
    );
};

export default ProdDetailOption2;
